import { StandardComboboxLabels } from '@brandfolder/react';

import { loaderLabel } from './loader';

export const getStandardComboboxLabels = (labels: Partial<StandardComboboxLabels> = {}): StandardComboboxLabels => {
  return {
    emptyLabel: bfTranslate('No options'),
    iconButtonLabel: bfTranslate('Toggle options'),
    label: bfTranslate('Options'),
    listboxLabel: bfTranslate('List of options'),
    loaderLabel,
    requiredLabel: bfTranslate('Required'),
    ...labels
  };
};
